// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"6144":"6fea767cad167c6c","7776":"b643af26b57c460a"}[chunkId] + ".js";
};